import React from 'react'
import AdminLayout from '../../components/admin/AdminLayout'

export default function AdminMyProperties() {
    return (
        <AdminLayout>
            <div className="flex flex-col md:flex-row md:items-center justify-between gap-6 mb-10">
                <div>
                    <h1 className="text-3xl font-bold text-slate-900 dark:text-white mb-2 leading-none capitalize">My Properties</h1>
                    <p className="text-slate-500 font-medium text-sm md:text-base">All internal classifieds properties managed directly by you.</p>
                </div>
            </div>

            <div className="bg-white dark:bg-slate-900 rounded-md p-8 border border-gray-100 shadow-sm">
                <div className="flex flex-col md:flex-row gap-4 items-center justify-between mb-8">
                    <h3 className="text-xl font-bold text-slate-800 dark:text-white leading-none">Your Managed Listings</h3>
                    <div className="px-4 py-1.5 bg-violet-50 text-violet-600 rounded-xl text-xs font-bold border border-violet-100">
                        Classified Active: 3
                    </div>
                </div>
                
                <div className="overflow-x-auto">
                    <table className="w-full text-left border-collapse">
                        <thead>
                            <tr className="border-b border-gray-200">
                                <th className="py-4 text-xs font-bold text-[#05144b] uppercase tracking-widest">Property Details</th>
                                <th className="py-4 text-xs font-bold text-[#05144b] uppercase tracking-widest">Location</th>
                                <th className="py-4 text-xs font-bold text-[#05144b] uppercase tracking-widest">Inquiries Received</th>
                                <th className="py-4 text-xs font-bold text-[#05144b] uppercase tracking-widest">Listing Date</th>
                                <th className="py-4 text-xs font-bold text-[#05144b] uppercase tracking-widest">Status</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-100">
                            <tr>
                                <td className="py-6">
                                    <div className="text-sm font-bold text-slate-800">Majestic Corporate Tower</div>
                                    <div className="text-xs text-slate-400 mt-1 uppercase tracking-wider">Premium Office</div>
                                </td>
                                <td className="py-6 text-sm text-slate-600">SG Highway, Ahmedabad</td>
                                <td className="py-6 text-sm text-slate-600 font-bold">18 Contacts</td>
                                <td className="py-6 text-sm text-slate-600">April 15, 2026</td>
                                <td className="py-6">
                                    <span className="px-3 py-1 bg-emerald-50 text-emerald-600 border border-emerald-100 rounded-full text-xs font-bold">Published</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </AdminLayout>
    )
}
